import React from 'react'
import InlineSVG from 'react-inlinesvg'

import './css/Welcome.css'
import arrow from './images/arrow.svg'

export default (props) => {

  return (
    <div className="Welcome animated fadeIn">
      <h1 className="WelcomeTitle">Hype Cycle</h1>
      <h2 className="WelcomeSubtitle">Test Your Knowledge Here</h2>
      <a className="bigButton" onClick={() => props.changeScreen('Game')}>Begin
        <InlineSVG className="hypeLine" src={arrow} />
      </a>
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/Welcome.js
 **/